import { space, tok, zIndex } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

export const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(100vh - ${space('primitives_space_48')}); // This adjust upper spacing of parent sheet
  height: calc(100dvh - ${space('primitives_space_48')}); // using dvh to support for Safari mobile
  display: flex;
  flex-direction: column;
  background: ${tok('semantics_views_background_color')};
  z-index: ${zIndex.level6};
`

const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
`

interface HeaderProps extends React.PropsWithChildren, React.HTMLAttributes<HTMLDivElement> {}

const RawHeader = ({ children, ...rest }: HeaderProps) => <HeaderWrapper {...rest}>{children}</HeaderWrapper>

export const Header = styled(RawHeader)``

export const Body = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: ${space('primitives_space_16')};
`

export const Footer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${space('primitives_space_12')};
  border-top: 1px solid ${tok('semantics_dividers_color')};

  > * {
    flex: 1;
  }
`
